import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const renameStorageLocation = {
  name: "renameStorageLocation" as const,
  input: z.object({
    storageLocationId: storageLocationIdFormat.schema,
    name: z.string().trim().min(1, "Name cannot be empty"),
  }),
  output: z.object({}),
};
